import { ContactPerson } from './contactPerson';

export class CustomerProfile {

  name: string;
  department: string;
  accountUnit: null;
  addressStreet: string;
  addressHouseNr: string;
  addressPostalCode: string;
  addressPostalBox: string;
  addressCity: string;
  addressCountry: string;

  contacts: ContactPerson[];

  constructor() {
    const cp = new ContactPerson();
    this.contacts = [ cp ];
    this.addressCountry = 'CHE';
  }

}



// WEBPACK FOOTER //
// ./src/models/customerProfile.ts